import { useMediaQuery } from '@mui/material'

const useMediaResponsive = () => {
  const minMedia1250 = useMediaQuery('(min-width: 1250px)')
  const minMedia900 = useMediaQuery('(min-width: 900px)')
  const minMedia800 = useMediaQuery('(min-width: 800px)')
  const minMedia600 = useMediaQuery('(min-width: 600px)')
  const minMedia450 = useMediaQuery('(min-width: 450px)')
  const minMedia420 = useMediaQuery('(min-width: 420px)')

  const maxMedia1250 = useMediaQuery('(max-width: 1250px)')
  const maxMedia900 = useMediaQuery('(max-width: 900px)')
  const maxMedia800 = useMediaQuery('(max-width: 800px)')
  const maxMedia600 = useMediaQuery('(max-width: 600px)')
  const maxMedia450 = useMediaQuery('(max-width: 450px)')
  const maxMedia420 = useMediaQuery('(max-width: 420px)')

  return {
    minMedia1250,
    minMedia900,
    minMedia800,
    minMedia600,
    minMedia450,
    minMedia420,
    maxMedia1250,
    maxMedia900,
    maxMedia800,
    maxMedia600,
    maxMedia450,
    maxMedia420
  }
}

export default useMediaResponsive
